import { render, staticRenderFns } from "./ParticipantsPage.vue?vue&type=template&id=6bc9c7f4&scoped=true&"
import script from "./ParticipantsPage.vue?vue&type=script&lang=js&"
export * from "./ParticipantsPage.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsPage.vue?vue&type=style&index=0&id=6bc9c7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc9c7f4",
  null
  
)

export default component.exports